var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'text-primary': !_vm.isValid }},[_vm._v("\n  "+_vm._s(_vm.strippedValue.length)+"/"+_vm._s(_vm.maxLength)+"\n  "),_c('help',[_vm._v("Maximum characters")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }